export default {
  loadingRequest: false,
  onboardingRequests: [],
  onboardingRequestsHeaders: [
    {
      sortable: true,
      text: 'Account ID',
      value: 'Acct_ID'
    },
    {
      sortable: false,
      text: 'Actions',
      value: 'Actions'
    },
    {
      sortable: true,
      text: 'Account Name',
      value: 'Acct_name'
    },
    {
      sortable: true,
      text: 'Onboarding Status',
      value: 'Onboarding_Status'
    }
  ],
  cloneRecord: {
    cloneDialog: false,
    add: false,
    view: false,
    acctName: null,
    shortName: '',
    addForm: false,
    addMessage:'',
    purpose: '', 
    isSpecificLocation:false,
    Restricted_Region_Id: '',
    isSpecificLocation: false,
    Specific_Location:'',
    loc:'',
    awsOnboarding: {
      Acct_name: null, 
      Client_Shortname: null, 
    },
    bulkCloneHeaders: [
      {
        sortable: false,
        text: 'Account Name',
        value: 'accountname'
      },
      {
        sortable: false,
        text: 'Client Shortname',
        value: 'shortname'
      },
    ],
    bulkRecords: []
  }, 

  updateAccount: {
    restrictedRegions:[],
    dxcRegions: ['APJ-MEA', 'Americas', 'Europe', 'UKI'],
    regions: ['All Region', 'amer', 'emea', 'eu', 'apac', 'anz'],
    purposes: [
      'Proof of Concept or Prototype(POC)',
      'Production(Prod)',
      'Staging(Stage)',
      'Quality Assurance (QA)',
      'Development (Dev)',
      'Test (Test)',
      'Demonstration (Demo)',
      'Sandbox (SB)',
      'Training'],
    awsServices: ['DXC Gold (CloudOps)', 'DXC Silver'],
    showDialog: false,
    loading: false,
    saving: false,
    awsValidation:{
      wbsCode: null,
      wbsValidating: false,
      wbsValidationMessage: '',
      wbsCodeValidated: false,
      wbsType: null,
      iwoCode: null,
      iwoValidating: false,
      iwoValidationMessage: '',
      iwoCodeValidated: false,
      agreed: false,
      submitting: false,
      savingForLater: false,
      savedForLater: false,
      isPromoCode:null,
      awsCredits: null
    },
    awsOnboarding:{
      isSaas: false,
      isSpecificRegion: true,
      isSpecificLocation: true,
      isCustomerRegulations: true,

      Acct_name:null,
      Specific_Region: null,
      SaaS:null,
      SaaS_Solution: null,
      Client_Shortname: null,
      Cust_Shortname: null,
      Restricted_Region_Id: null,
      Specific_Location: null,
      Customer_Regulations:[],
      Acct_Description: null, 
      GovCloud_Resource_Account: null,
      AWS_Purpose: {
        all: [],
        poc: {
          q1: null,
          q2: null,
          q3: null,
          q4: null,
          q5: null
        }
      },
      Managed_Svc: null, 
      AWS_Support_Type: null
    },
    awsAccountContact: {
      acctOwner: {
        name: null,
        phone: null,
        email: null
      },
      submitting: false,
      submitted: false,
      contactStatus: false,
      contactStatusMsg: null,
      Account_Owners: [],
      CloudCheckr_users: [],
      IAM_Users:[],
      Notification_List: [],
      Financial_Owner: [],
    },
    fields: {
      Onboarding_Id: null,
      Project_Id: null,
      OppReg_Id: null, 
      Acct_ID: null,
      Acct_name: null, 
      Acct_DL:null,
      Requestor_Id: null,
      Requestor_FullName: null,
      Contact_Id:null,
      Client_Shortname: null,
      Contact_FullName: null,
      WBS_code: null,
      IWO_Code: null,
      AWS_credits: null,
      Account_Owners:null,
      Financial_Id:null,
      IAM_Users: null,
      Notification_List: null,
      CLoudCheckr_users: null,
      AWS_Support_Type: null,
      SaaS_Solution: null,
      Acct_Description: null,
      Specific_Region: null,
      Specific_Location: null,
      Account_Purpose: null,
      Managed_Svc: null,
      SaaS: null,
      Onboarding_Status: null,
      Date_Requested: null,
      Restricted_region_Id: null,
      Request_Type: null,
      Business_Use: null,
      OBS_Date_Updated: null,
      Engr_Assigned_To:null,
      Customer_Regulations: null,
      AWS_Req_Type: null,
      MP_ID: null,
      GovCloud_Resource_Account: null,
    },
    record: {
      financial: {
        isAwsCredits:false,
        Financial_Id: null,
        wbsCode: null,
        wbsValidating: false,
        wbsValidationMessage: '',
        wbsCodeValidated: false,
        wbsType: null,
        iwoCode: null,
        iwoValidating: false,
        iwoValidationMessage: '',
        iwoCodeValidated: false,
        agreed: false,
        submitting: false,
        savingForLater: false,
        savedForLater: false,
        isPromoCode:null,
        awsCredits: null
      }
    },

    accountOwners: [
      {
        text: 'Actions',
        value: 'Actions',
        sortable: false,
        align: 'left'
      },
      {
        text: 'Name',
        value:'name'
      },
      {
        text: 'Phone',
        value: 'phone'
      },
      {
        text: 'Email',
        value: 'email'
      }
    ]

  }
}
